import { COMMON, ifyouApi, kevinAuthAPI, STORY } from 'apis/config';
/**
 * * 리소스 - 미니컷 Api
 */

export const minicutApi = {
  read: (projectId: string, lang: string) =>
    kevinAuthAPI
      .get(`resource-manager/static/${projectId}/minicut`)
      .then((res) => res.data),
  detail: (projectId, minicutId) =>
    ifyouApi
      .post(`${STORY}/${projectId}/mini-detail`, {
        minicut_id: minicutId,
        minicut_type: 'minicut',
      })
      .then((res) => res.data),
  register: ({ projectId, formData }) =>
    kevinAuthAPI
      .post(`/resource-uploader/multi-upload/${projectId}/minicut`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data),
  update: ({ projectId, formData }) =>
    ifyouApi
      .post(`${STORY}/${projectId}/mini-update`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data),
  zipUpload: ({ projectId, formData }) =>
    ifyouApi
      .post(`${STORY}/${projectId}/mini-zip-upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data),
  delete: ({ projectId, minicutId }) =>
    ifyouApi
      .post(`${STORY}/${projectId}/mini-delete`, {
        minicut_id: minicutId,
      })
      .then((res) => res.data),
  // 연결 리소스 -  미니컷,
  fetchMinicutPair: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'getLivePairList',
        code: 'object',
        project_id: projectId,
      })
      .then((res) => res.data),
  // new api
  minicutList: (projectId: string) =>
    kevinAuthAPI
      .get(`/resource-manager/static/${projectId}/minicut`)
      .then((res) => res.data)
      .catch((error) => {
        console.log(error);
      }),
  minicutDelete: (id: string) =>
    kevinAuthAPI
      .delete(`/resource-manager/static/${id}`)
      .then((res) => res.data)
      .catch((error) => {
        console.log(error);
      }),
  InsertMultiMinicut: (projectId: string, data) =>
    kevinAuthAPI
      .post(`/resource-uploader/multi-upload/${projectId}/minicut`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data)
      .catch((err) => console.log(err)),
  minicutUpdateThumbnail: (projectId: string, id: string, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return kevinAuthAPI
      .post(`/resource-manager/static-thumbnail/${projectId}/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },
  minicutUpdateImage: (projectId: string, id: string, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return kevinAuthAPI
      .patch(`/resource-manager/static/${projectId}/minicut/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },
  minicutUpdateInfor: (projectId: string, id: string, data) =>
    kevinAuthAPI
      .put(`/resource-manager/static/${projectId}/minicut/${id}`, data)
      .then((res) => res.data)
      .catch((err) => console.log(err)),
};
